import React, { FC, useEffect } from 'react';
import {
  NavLinkStyled,
  ProjectAdminListContainerStyled,
  AdminListCollapsedStyled,
  MenuItemStyled,
  ListContainerStyled,
  ExpandCollapseBorderBoxStyled,
  ExpandCollapseBoxStyled,
} from './styled';
import { Box, Text, IconSize, Icon } from '@bechtel/gds';
import { ProjectAdminListProps, ProjectAdminMenuItem, ProjectAdminMenuType } from './types';
import { find, map } from 'lodash';
import { useNavigate, useLocation } from 'react-router';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { useProjectAdminMenu } from './hooks';

export const ProjectAdminList: FC<ProjectAdminListProps> = ({ isListCollapsed, onToggleCollapse }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getProjectAdminMenuItems } = useProjectAdminMenu();
  // NOTE: used for auto selecting General menu item if one is not already
  const { i18n } = useLingui();
  const projectAdminMenuItems = getProjectAdminMenuItems();

  useEffect(() => {
    if (location.pathname === '/project-admin') {
      const prjGeneralMenuItem = find(projectAdminMenuItems, (item: ProjectAdminMenuItem) => {
        return item.type == ProjectAdminMenuType.GENERAL;
      });
      navigate(`${prjGeneralMenuItem?.value}`);
    }
  }, [navigate, location.pathname]);

  return (
    <ListContainerStyled isListCollapsed={isListCollapsed}>
      <ProjectAdminListContainerStyled isListCollapsed={isListCollapsed}>
        <Box
          px={{ sm: '500' }}
          py={{ sm: '600' }}
          css={`
            ${({ theme }) => `border-bottom: solid 1px ${theme.colors.grey[300]} `}
          `}
        >
          <Text family="graphik" size="500" weight="600">
            <Trans>Project Settings</Trans>
          </Text>
        </Box>
        <Box flexDirection={{ sm: 'column' }} style={{ overflowY: 'auto' }}>
          {map(projectAdminMenuItems, (item: ProjectAdminMenuItem) => {
            return (
              <NavLinkStyled to={`/project-admin/${item.value}`} key={item.value}>
                <MenuItemStyled>{i18n._(item.label)}</MenuItemStyled>
              </NavLinkStyled>
            );
          })}
        </Box>
      </ProjectAdminListContainerStyled>
      <AdminListCollapsedStyled isListCollapsed={isListCollapsed}></AdminListCollapsedStyled>
      <ExpandCollapseBorderBoxStyled isListCollapsed={isListCollapsed}>
        <ExpandCollapseBoxStyled onClick={onToggleCollapse}>
          <Icon icon={isListCollapsed ? 'chevron-right' : 'chevron-left'} size={IconSize.MEDIUM} fillColor="blue.800" />
        </ExpandCollapseBoxStyled>
      </ExpandCollapseBorderBoxStyled>
    </ListContainerStyled>
  );
};
